var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.6 4H12.42C7.78002 4 4.02002 7.76 4.02002 12.38V24.74V25.12C4.02002 29.76 7.78002 33.5 12.4 33.5H19.6C20.7 33.5 21.6 34.4 21.6 35.5V37.14C21.6 38.24 20.7 39.14 19.6 39.14H15.1C14.32 39.14 13.68 39.78 13.68 40.56C13.68 41.34 14.32 41.98 15.1 41.98H30.96C31.74 41.98 32.38 41.34 32.38 40.56C32.38 39.78 31.74 39.14 30.96 39.14H26.46C25.36 39.14 24.46 38.24 24.46 37.14V35.5C24.46 34.4 25.36 33.5 26.46 33.5H33.6C38.24 33.5 41.98 29.74 41.98 25.12V24.74V12.38C41.98 7.76 38.22 4 33.6 4Z",
    fill: "url(#paint0_linear_150_32973)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.28 19H28.7C25.24 19 23.98 20.26 23.98 23.76V39.22C23.98 42.74 25.22 43.98 28.7 43.98H39.28C42.74 43.98 44 42.72 44 39.22V23.76C44 20.24 42.76 19 39.28 19ZM34 40.64C32.78 40.64 31.8 39.66 31.8 38.44C31.8 37.22 32.78 36.24 34 36.24C35.22 36.24 36.2 37.22 36.2 38.44C36.2 39.66 35.22 40.64 34 40.64Z",
    fill: "url(#paint1_linear_150_32973)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.2001 38.44C36.2001 39.66 35.22 40.64 34 40.64C32.78 40.64 31.8 39.66 31.8 38.44C31.8 37.22 32.78 36.24 34 36.24C35.22 36.24 36.2001 37.24 36.2001 38.44Z",
    fill: "url(#paint2_linear_150_32973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_32973",
    x1: 3.99901,
    y1: 22.9902,
    x2: 42.001,
    y2: 22.9902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_32973",
    x1: 10.9995,
    y1: 48.5,
    x2: 58.9995,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_32973",
    x1: 31.7976,
    y1: 38.44,
    x2: 36.2025,
    y2: 38.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorMobile);
export default __webpack_public_path__ + "static/media/monitor-mobile.bc891c58b05d48a8ddf250cbe9377a88.svg";
export { ForwardRef as ReactComponent };